// extracted by mini-css-extract-plugin
module.exports = {"change-container":"style_change-container__-D-hj","buttons":"style_buttons__3YFTB"};